import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import HeaderSummary from './HeaderSummary';
import ReviewsList from './ReviewsList';
import { isSolvPartner } from '../../../../core/util/location';
import PanelCard from '../../PanelCards/components/PanelCard';

export default class Reviews extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    enableCollapsing: PropTypes.bool,
    defaultExpanded: PropTypes.bool,
    showModal: PropTypes.func,
    isReadOnly: PropTypes.bool,
  };

  render = () => {
    const { enableCollapsing, defaultExpanded, showModal, location, isReadOnly } = this.props;
    const overallRating = isSolvPartner(location) ? location.ratingSolv : location.ratingNonSolv;
    const ratingCount = isSolvPartner(location)
      ? location.ratingSolvCount
      : location.ratingNonSolvCount;

    return (
      <Fragment>
        <a name="reviews" />
        <PanelCard title="Ratings & Reviews" {...{ enableCollapsing, defaultExpanded }}>
          <div>
            <HeaderSummary
              locationId={location.id}
              overallRating={Math.round(overallRating * 10) / 10}
              ratingCount={ratingCount}
              waitTimeRating={parseFloat(location.ratingWaitTime)}
              waitTimeRatingCount={location.ratingWaitTimeCount}
              qualityOfCareRating={parseFloat(location.ratingQualityOfCare)}
              qualityOfCareRatingCount={location.ratingQualityOfCareCount}
              bedsideMannerRating={parseFloat(location.ratingBedsideManner)}
              bedsideMannerRatingCount={location.ratingBedsideMannerCount}
              friendlinessRating={parseFloat(location.ratingStaffFriendliness)}
              friendlinessRatingCount={location.ratingStaffFriendlinessCount}
              cleanlinessRating={parseFloat(location.ratingFacilityCleanliness)}
              cleanlinessRatingCount={location.ratingFacilityCleanlinessCount}
              showModal={showModal}
              isReadOnly={isReadOnly}
            />
            <ReviewsList showModal={showModal} />
          </div>
        </PanelCard>
      </Fragment>
    );
  };
}
